export default class Context{
  //TODO change var context on type, and make this static methods more sensible
    constructor (context, idTable=null) {
      if(![Context.FORM, Context.TABLE].includes(context)
        || ( context == Context.TABLE && idTable == null)){

          throw "Bad context configuration"
      }

      this.context = context
      this.idTable = undefined
      this._fields = undefined
      this._records = undefined
      this._parent = undefined

      if(this.context == Context.TABLE){
        this.idTable = idTable
      }
    }

    static createFormContext(){
      return new Context(Context.FORM)
    }

    static createTableContext(idTable){
      return new Context(Context.TABLE, idTable)
    }

    static createTabelContextWithFields(idTable,field){
      let context = new Context(Context.TABLE, idTable)
      context.setFields(field)
      return context
    }

    static createFormContextWithFields(fields){
      let context = new Context(Context.FORM)
      context._fields=fields
      return context
    }

    static createFullFormContext(fields, records){
        let context = new Context(Context.FORM)
        context._fields=fields
        context._records= records
        return context
    }


    static createFullTableContext(idTable, fields, records, parent){
        let context = new Context(Context.TABLE, idTable)
        context._fields=fields
        context._records= records
        context._parent = parent
        return context
        }

    static createTableContextWithParent(parent, idTable, contextFields){
      let context =  new Context(Context.TABLE, idTable)
      context._fields = contextFields
      context._parent = parent
      return context
    }

    getFieldInterface(id){
      let field = this.getFields().find(field => field.id == id)
      if(field == undefined){
        if(this._parent != undefined){
          field = this._parent.getFieldInterface(id)
         }
      }
      return field
    }


    findRecordField(id){
      for(let key in this._records){
        if(this._records[key] && this._records[key].id == id){
          return this._records[key]
        }
      }
    }

    getFieldValue(fieldInterface){
      return this.getFieldValueById(fieldInterface.id)
    }

    getFieldValueById(id){
      let recordField = this.findRecordField(id)

      if(recordField == undefined){
         if(this._parent == undefined){
          return undefined
          }
        return this._parent.getFieldValueById(id)
      }

      return recordField.data
    }

    getParent(){
      return this._parent
    }

    getFields(){
      if(this._parent != undefined){
        return [].concat(this._fields, this._parent.getFields())
      }
      return this._fields
    }

    getIdTable(){
      return this.idTable
    }

    static get FORM() {
      return "form";
    }

    static get TABLE() {
      return "table";
    }

}
